import { decode } from 'js-base64'
import { isClientSide } from './ssrUtils'

export const getElementWidth = (element: string): number | undefined => {
    if (isClientSide) {
        const domElement = document.getElementById(element)
        if (domElement) {
            const computedElement = getComputedStyle(domElement)
            const paddingX = parseFloat(computedElement.paddingLeft) + parseFloat(computedElement.paddingRight)
            const borderX = parseFloat(computedElement.borderLeftWidth) + parseFloat(computedElement.borderRightWidth)
            return domElement.offsetWidth - paddingX - borderX
        }

        return 0
    }
}

export const resolveBase64Namespace = (value: string): string => {
    const decodedValue = decode(value)
    const isSvg = decodedValue.startsWith('<svg') || decodedValue.startsWith('<?xml')
    const namespace = isSvg ? 'data:image/svg+xml' : 'data:image/png'
    return namespace
}
